import { FC } from 'react';

import OrganizationHeader from '../../../components/OrganizationHeader';

import HelpMenu from './HelpMenu';
import SideMenu from './SideMenu';
import styles from './styles.module.less';

type MenuProps = {
  collapsed?: boolean;
  onToggle: () => void;
};

const Menu: FC<MenuProps> = ({ onToggle, ...rest }) => {
  return (
    <div className={styles.container}>
      <OrganizationHeader {...rest} />
      <SideMenu {...rest} />
      <HelpMenu {...rest} onToggle={onToggle} />
    </div>
  );
};

Menu.displayName = 'Menu';

export default Menu;
